module.exports = __webpack_public_path__ + "img/basket-product-remove.a7e9198d.svg";